import * as t from 'io-ts';

export const unitFeaturesDecoder = t.partial({
    propertyType: t.union([
        t.literal('apt/loft'),
        t.literal('condo'),
        t.literal('hotel'),
        t.literal('house'),
        t.literal('shared room'),
        t.literal('special'),
        t.literal('townhome'),
    ]),
    bedrooms: t.number,
    bathrooms: t.number,
    annualPrediction: t.number,
    annual_prediction_source: t.string,
    monthlyPredictions: t.record(t.string, t.number),
    calendarYearMonthlyPredictions: t.record(t.string, t.number),
    compVacasaUnits: t.array(
        t.type({
            unitID: t.number,
            haversineDistance: t.number,
        }),
    ),
    address: t.string,
    squareFootage: t.number,
    maxOccupancy: t.number,
    min_rate: t.number,
    minMinStay: t.number,
    isSkiInSkiOut: t.boolean,
    isWaterfront: t.boolean,
    hasOven: t.boolean,
    hasPrivatePool: t.boolean,
    has_private_hot_tub: t.boolean,
    has_washerdryer: t.boolean,
    has_gas_grill: t.boolean,
    has_gas_fireplace: t.boolean,
    guestRating: t.number,
    num_owner_holds: t.number,
    nightlyRates: t.type({
        minRate: t.string,
        lostRevenue: t.string,
    }),
    unitid_nearby: t.array(t.number),
    unitid_similar: t.array(t.number),
    prediction_band_low: t.number,
    prediction_band_high: t.number,
});

export const createUnitFeaturesDecoder = t.type({
    address: t.string,
    bedrooms: t.number,
    bathrooms: t.number,
});

export const updateNightlyRatesDecoder = t.type({
    nightlyRates: t.type({
        minRate: t.string,
        lostRevenue: t.string,
    }),
});

export type UnitFeatures = t.TypeOf<typeof unitFeaturesDecoder>;
